export const getVisiblePages = (
  currentPage: number,
  totalPages: number
): (number | 'ellipsis')[] => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index)
  }

  const pages: (number | 'ellipsis')[] = []

  let startPage: number
  let endPage: number

  if (currentPage <= 2) {
    startPage = 1
    endPage = 3
  } else if (currentPage >= totalPages - 3) {
    startPage = totalPages - 4
    endPage = totalPages - 2
  } else {
    startPage = currentPage - 1
    endPage = currentPage + 1
  }

  pages.push(0)

  if (startPage > 1) {
    pages.push('ellipsis')
  }

  for (let pageIndex = startPage; pageIndex <= endPage; pageIndex += 1) {
    pages.push(pageIndex)
  }

  if (endPage < totalPages - 2) {
    pages.push('ellipsis')
  }

  pages.push(totalPages - 1)

  return pages
}
